<template>
  <div v-if="address">
    <div :class="['address-container', addressTextColor]">
      <i
        v-if="address.invalid && !address.manual_entry"
        class="fa fa-exclamation-circle mr-1 mt-1 sera-color-error-text"
      ></i>
      <div class="address-label">
        <span class="d-flex single">
          <span class="mr-1">
            <span v-if="label" class="text-title">
              {{ label }}
            </span>
            <span>
              {{ invalidOrManualText(address) }}
              {{ fullAddress(address) }}
            </span>
          </span>
        </span>
      </div>
    </div>
    <div v-if="locationType" class="mt-2">
      <span class="text-title">Type:</span> {{ getTypeLabel() }}
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters } from "vuex";

import { fullAddress } from "@/mixins";
import { Address } from "@/typings/address";
import { locationTypeLabel } from "../mixins";

export default {
  props: {
    address: {
      type: Object as () => Address,
      default: null
    },
    locationType: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["featureEnabledForTenant"]),
    addressTextColor() {
      return this.address.invalid && !this.address.manual_entry
        ? "text-danger"
        : "";
    }
  },
  methods: {
    fullAddress,
    getTypeLabel() {
      return locationTypeLabel(this.address);
    },
    invalidOrManualText(address: Address) {
      if (address.invalid && !address.manual_entry) {
        return "Invalid - ";
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.address-container {
  display: flex;
  flex: row;
}

.address-label {
  display: flex;
  flex-direction: column;
  white-space: normal;
  &.single {
    flex-direction: row;
    white-space: nowrap;
  }
}

.street-label {
  flex-direction: row;
}
</style>
